import { Flex, Text, Button, Link } from "@chakra-ui/react";
import { BsFillCameraFill } from "react-icons/bs";

export const InputVisualizarFoto = ({ foto, dados, openFotoView, photo }) => {

  return (
    <Button
      as="a"
      href={photo}
      target="_blank"
      rel="noopener noreferrer"
      cursor="pointer"
      bg={"#378BBF"}
      color={"white"}
      _hover={{ filter: "brightness(0.9)" }}
      height="2rem"
      transition="filter 0.2s"
      onClick={openFotoView}
    >
      <BsFillCameraFill size={20} />
      <Link
        href={photo}
        target="_blank"
        rel="noopener noreferrer"
        fontSize={[".8rem"]}
        ml={2}
      >
        {foto}
      </Link>
    </Button>
  );
};
